var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreshchatOutlined = function SvgFreshchatOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.971 35.943C8.034 35.943 0 27.909 0 17.97 0 8.034 8.034 0 17.971 0h13.532a4.51 4.51 0 0 1 4.546 4.546V17.97c0 9.938-8.035 17.972-18.078 17.972"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.314 15.962H13.743a.833.833 0 0 1-.846-.845c0-.529.423-.846.846-.846h10.571c.529 0 .846.423.846.846 0 .424-.423.845-.846.845m-4.017 4.229h-6.554a.833.833 0 0 1-.846-.846c0-.422.423-.845.846-.845h6.554c.529 0 .846.423.846.845a.833.833 0 0 1-.846.846m3.277-9.62H14.59a4.51 4.51 0 0 0-4.546 4.546v7.717c0 .528.423.951.951.951H23.47a4.51 4.51 0 0 0 4.545-4.544v-4.124c0-2.537-2.008-4.546-4.44-4.546"
  }))));
};
export default SvgFreshchatOutlined;